module.exports = __webpack_public_path__ + "src/assets/img/coupon-bg.80b13bca.png";